import { ButtonToggleProps } from 'core/button-toggle/button-toggle.props';

export const ButtonTogglePresets: Partial<ButtonToggleProps> = {
  lineHeight: '1.6rem',
  selectedBackgroundColor: 'primary',
  variant: 'p3',
};
